import { render, staticRenderFns } from "./FolderWokflowDetail.vue?vue&type=template&id=19d186e6&scoped=true"
import script from "./FolderWokflowDetail.vue?vue&type=script&lang=js"
export * from "./FolderWokflowDetail.vue?vue&type=script&lang=js"
import style0 from "./FolderWokflowDetail.vue?vue&type=style&index=0&id=19d186e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d186e6",
  null
  
)

export default component.exports